import Hero from '../../components/Hero';
import NavigationBar from '../../components/NavigationBar';
import Footer from '../../components/Footer';
import Partners from '../../components/Partners';
import CookieBanner from '../../components/CookieBaner';
import Bikes from "../../components/Content/Bikes"
import PriceTable from '../../components/Content/PriceTable';
import Gallery from '../../components/Gallery';
import { bikesImages } from "../../components/Content/Bikes/images/bikesImages";
import { Container } from '../../components/Content/styled';
import BikesHero480 from "./images/bikesHero480p.webp";
import BikesHero768 from "./images/bikesHero768p.webp";
import BikesHero1080 from "./images/bikesHero1080p.webp";
import BikesHero1440 from "./images/bikesHero1440p.webp";
import GoogleMap from '../../components/Content/GoogleMap';
import Address from '../../components/Content/Address';
import BikeRental from '../../components/Content/Bikes/BikeRental';

function BikesPage() {
    return (
        <>
            <NavigationBar variant="bikes" />
            <main>
                <Hero variant="bikes" images={{
                    480: BikesHero480,
                    768: BikesHero768,
                    1080: BikesHero1080,
                    1440: BikesHero1440,
                }} />
                <Container>
                    <Bikes />
                    <BikeRental />
                    <PriceTable variant="bikesRental" />
                    <Address variant="bikesRental" />
                    <GoogleMap variant="bikesRental" />
                </Container>
                <Gallery images={bikesImages} variant="bikes" />
                <Partners />
            </main>
            <Footer />
            <CookieBanner />
        </>
    );
}
export default BikesPage;